export default __webpack_public_path__ + "static/media/mixkit-positive-interface-beep-221.cba6b6d5.wav";